export enum STEPS {
    STEP_IDENTIFICATION = 1,
    STEP_TOKEN = 2,
    STEP_NEW_PASSWORD = 3,
    STEP_SUCCESS = 4,
    STEP_ERROR = 5,
}
